import type { Event, EventHint } from "@sentry/core";

/**
 * beforeSend hook that drops authenticated 403s raised by the apps/nextjs Error page (the same
 * "Unexpected authenticated <status>" events that fingerprintAuthenticatedError groups) when an
 * impersonation session is active. Impersonators routinely trip permission boundaries the real
 * user wouldn't, so these are noise, not bugs.
 *
 * Gated on the `http.status` tag set in apps/nextjs/src/components/Error.tsx and the `imposter_id`
 * set by setUserInSentry — both only present on the Next.js client, which is the only place these
 * fire. Server-side 403s (RemiAppError with errorType UNAUTHORIZED) are filtered in @remi/sentry's
 * base config instead.
 */
export function dropImpersonated403<T extends Event>(event: T, _hint: EventHint): T | null {
  if (event.user?.imposter_id && event.tags?.["http.status"] === "403") {
    return null;
  }
  return event;
}
